import { InstantAnswerBuilderFn } from "@faire/help-center-self-serve/types";
import { StrictLocalizeFunction } from "@faire/web--source/common/localization";

import { RequestCreditLimitIncreaseCTA } from "./ctas";

export const RequestCreditLimitIncreaseIA: InstantAnswerBuilderFn = (
  strictLocalize
) => {
  return {
    titleBuilder: (_context) => {
      return REQUEST_CREDIT_LIMIT_INCREASE(strictLocalize);
    },

    descriptionBuilder: (_context) => {
      return [
        SUBMIT_REQUEST_USING_BUTTON(strictLocalize),
        PLEASE_NOTE(strictLocalize),
        TIMELINE(strictLocalize),
      ];
    },

    primaryCtaBuilder: {
      textBuilder: (_context) => {
        return RequestCreditLimitIncreaseCTA(strictLocalize).label;
      },
      linkBuilder: (_context) => {
        return RequestCreditLimitIncreaseCTA(strictLocalize).getLink?.();
      },
    },
  };
};

const REQUEST_CREDIT_LIMIT_INCREASE = (
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize({
    defaultMessage: "Request credit limit increase",
    description: {
      text: "Title for the answer of how to request a credit limit increase",
    },
  });

const SUBMIT_REQUEST_USING_BUTTON = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage:
      "If you would like to apply to increase your limit, please click on the button below to submit a request.",
    description: {
      text: "Part of the answer for how to request a credit limit increase",
    },
  });

const PLEASE_NOTE = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage:
      "Please note, if you've applied for an increase within the last 3 months, your account may not have this button and instead require manual review from our payments team.",
    description: {
      text: "Part of the answer for how to request a credit limit increase",
    },
  });

const TIMELINE = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage:
      "We will review your application and you will typically hear back from us in 3-7 business days.",
    description: {
      text: "Part of the answer for how to request a credit limit increase",
    },
  });
